import {ChangeDetectionStrategy, Component, ViewEncapsulation} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-followups-list-all",
    template: `
        <h1 class="container-heading">Followups</h1>
        <mat-card>
            <mat-card-content>
                <section-followups-list [state]="state"></section-followups-list>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class FollowupsListAllComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "followups-all",
            actions: {
                "browse": ["see_all_followups"],
                "search": ["see_all_followups"],
            }
        };
    }
}
